let audioCtx = null;
let titleResetTimer = null;

export function unlockComplaintRing() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) audioCtx = new Ctx();
    if (audioCtx.state === 'suspended') {
      audioCtx.resume().catch(() => {});
    }
  } catch {
    /* ignore */
  }
}

/** Phone-style double ring (~3s). Needs a prior user gesture to unlock audio. */
export function playComplaintRing() {
  unlockComplaintRing();
  if (!audioCtx) return;
  const ctx = audioCtx;
  const now = ctx.currentTime;
  const bursts = [
    [0, 0.4],
    [0.55, 0.95],
    [1.8, 2.2],
    [2.35, 2.75],
  ];
  bursts.forEach(([start, end]) => {
    [440, 480].forEach((freq) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(0.14, now + start + 0.02);
      gain.gain.setValueAtTime(0.14, now + end - 0.05);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + end);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + end + 0.03);
    });
  });
}

export async function requestComplaintNotifyPermission() {
  if (typeof Notification === 'undefined') return 'denied';
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Notification.permission;
  }
  try {
    return await Notification.requestPermission();
  } catch {
    return 'denied';
  }
}

export function showComplaintBrowserNotification({ title, body, url }) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  try {
    const n = new Notification(title, {
      body,
      tag: url || 'roadserve-new-complaint',
      requireInteraction: true,
    });
    n.onclick = () => {
      try {
        window.focus();
        if (url) window.location.assign(url);
      } catch {
        /* ignore */
      }
      n.close();
    };
  } catch {
    /* ignore */
  }
}

export function flashComplaintTitle(label = 'New complaint') {
  if (typeof document === 'undefined') return;
  const prev = document.title.replace(/^●\s+/, '');
  document.title = `● ${label}`;
  if (titleResetTimer) clearTimeout(titleResetTimer);
  titleResetTimer = setTimeout(() => {
    if (document.title.startsWith('●')) document.title = prev;
  }, 10000);
}
